import React from "react";

import TextBlock from "../components/textBlock";

type TokenizationViewProps = {
	data: {
		isTsysTokenizationEnabled: string;
	};
	noMarging?: boolean;
};

const TokenizationView = ({ data, noMarging }: TokenizationViewProps) => {
	const { isTsysTokenizationEnabled } = data || {};

	const isTsysTokenization =
		isTsysTokenizationEnabled === "true" ? true : false;

	return (
		<TextBlock
			label="Tokenization"
			value={isTsysTokenization ? "Yes" : "No"}
			dataAutotest="tsysTokenization"
			noMarging={noMarging}
		/>
	);
};

export default TokenizationView;
